import { KeyValuePairCollection } from './kvp.collection';

export const WarrantyChannel: KeyValuePairCollection<string> = new KeyValuePairCollection<string>([
  { key: 'Warranty', value: 'WAR' }
]);
